<template>
  <label class="label">
    <input
      type="checkbox"
      class="label__checkbox"
      :checked="checked"
      :value="value"
      @change="onChange"
    >

    <div
      class="label__fake"
    />

    <span
      v-text="label"
      class="label__title"
    />
  </label>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  props: {
    modelValue: {},
    value: {},
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      localChecked: false
    }
  },
  computed: {
    isArray () {
      return Array.isArray(this.modelValue)
    },
    checked () {
      if (this.isArray) {
        return this.localChecked.includes(this.value)
      } else {
        return this.localChecked
      }
    }
  },
  watch: {
    modelValue: 'init'
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.isArray) {
        this.localChecked = this.modelValue.slice()
      } else {
        this.localChecked = !!this.modelValue
      }
    },
    onChange (event) {
      if (this.isArray) {
        const exists = this.localChecked.includes(this.value)

        if (exists) {
          this.localChecked = this.localChecked.filter(item => item !== this.value)
        } else {
          this.localChecked.push(this.value)
        }

        this.$emit('update:modelValue', this.localChecked)
      } else {
        this.$emit('update:modelValue', event.target.checked)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  display: inline-flex;
  align-items: center;
  padding: 2px;
  user-select: none;

  &__checkbox {
    display: none;
  }

  &__checkbox:checked + div {
    background-color: #D76014;
    border-color: #D76014;
    background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 214.155 214.155' style='enable-background:new 0 0 214.155 214.155;' xml:space='preserve'%3E%3Cpath fill='%23fff' d='M74.551,193.448L0,118.896l33.136-33.135l41.415,41.415L181.02,20.707l33.135,33.136L74.551,193.448z'/%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 70%;
  }

  &__fake {
    width: 24px;
    height: 24px;
    display: inline-block;
    border: 2px solid #ABABAB;
    border-radius: 8px;
  }

  &__title {
    margin-left: 12px;
    font-size: 14px;
  }
}
</style>
